var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDevTools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500.2 500.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#018b9d;}.cls-2{fill:none;stroke:#018b9d;stroke-miterlimit:10;stroke-width:14px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coloured_icons",
    "data-name": "Coloured icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M426.89,73.31A250.1,250.1,0,0,0,0,250.1,250.3,250.3,0,0,0,250.1,500.2c66.82,0,129.66-25.87,176.79-73.31A248.62,248.62,0,0,0,500.2,250.1c-.31-66.82-26.18-129.45-73.31-176.79ZM415.58,415.79A234.36,234.36,0,0,1,84.31,84.2a234.66,234.66,0,0,1,331.58,0,234.28,234.28,0,0,1-.31,331.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M420.08,112.27a7.81,7.81,0,0,0-12,10A203,203,0,0,1,115,401.33a7.78,7.78,0,0,0-11,.53,7.87,7.87,0,0,0,.52,11,218.22,218.22,0,0,0,300.37-8.38,217.11,217.11,0,0,0,64.2-154.68,221.49,221.49,0,0,0-49-137.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.92,250C46.92,138.14,138,47,250.1,47A202.75,202.75,0,0,1,385.52,98.66,7.78,7.78,0,1,0,396,87.14,218.61,218.61,0,0,0,95.31,95.52,216.46,216.46,0,0,0,31.11,250a219.26,219.26,0,0,0,48.7,137.72,8,8,0,0,0,6,2.93,7.18,7.18,0,0,0,5-1.88,7.53,7.53,0,0,0,1-11A205.24,205.24,0,0,1,46.92,250Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M200.94,272.65a8.58,8.58,0,0,1-11.26,10.4L159.6,253.23V251l29.66-29.4A8.78,8.78,0,0,1,201,232.92l-19.3,19.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M277.67,195.49,232.91,309.13a10.36,10.36,0,0,1-18.34-.57l44.76-114a11.36,11.36,0,0,1,10.73-4.32A11.54,11.54,0,0,1,277.67,195.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M310.58,252.21l-19.3-19.29A8.78,8.78,0,0,1,303,221.64L332.64,251v2.19l-30.08,29.82a8.58,8.58,0,0,1-11.26-10.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 104.09,
    y: 142.3,
    width: 292.02,
    height: 215.59,
    rx: 12
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevTools);
export default __webpack_public_path__ + "static/media/DevTools.560cd18b812c84f58621485bd72785ea.svg";
export { ForwardRef as ReactComponent };